import Link from '@/_application/core/components/ui/link';
import {ArrowNextIcon} from '@/_application/icons/arrow-next';
import {isEmpty} from 'lodash';
import {useTranslation} from 'next-i18next';

export interface BreadcrumbInterface {
    id: string;
    url: string;
    title: string;
}

interface IProps {
    items: BreadcrumbInterface[];
}

const BreadCrumbs = ({items}: IProps) => {
    const {t} = useTranslation();
    return (
        <div className="flex items-center gap-2 text-sm md:text-base">
            <div className="flex items-center gap-2">
                <Link href="/" className="text-primary/80 hover:text-primary hover:underline">
                    {t('text-home')}
                </Link>
            </div>
            {items.map(crumb => (
                <div className="flex items-center gap-2" key={crumb.id}>
                    <span>
                        <ArrowNextIcon className="mb-[3px] h-2.5 w-2.5 text-primary md:mb-px md:h-3 md:w-3" />
                    </span>
                    {!isEmpty(crumb.url) ? (
                        <Link href={crumb.url} className="text-primary/80 hover:text-primary hover:underline">
                            {crumb.title}
                        </Link>
                    ) : (
                        <p className="text-primary/80 ">{crumb.title}</p>
                    )}
                </div>
            ))}
        </div>
    );
};
export default BreadCrumbs;
